import React from "react";
import { useHistory } from "react-router-dom";

import { Body, PageTitle } from "src/components/typography/typography";
import { Routes } from "src/utils/routes";

import "./admin.scss";

/*
 * Types
 */

interface AdminLayoutProps {
    children: React.ReactNode;
}

/*
 * Main
 */

export const AdminLayout = (props: AdminLayoutProps): React.ReactElement => {
    const { children } = props;

    const history = useHistory();

    return (
        <div className="main-page-wrap home">
            <div className="center">
                <div className="page-section no-margin title-extra-wrap">
                    <PageTitle>Admin Actions</PageTitle>
                    <div className="admin__actions">
                        <button
                            className="jump-to-link"
                            onClick={(): void => {
                                history.push(Routes.admin.createSchool);
                            }}
                        >
                            Create School
                        </button>
                        <span className="divider">|</span>
                        <button
                            className="jump-to-link"
                            onClick={(): void => {
                                history.push(Routes.admin.createUser);
                            }}
                        >
                            Create User
                        </button>
                        <span className="divider">|</span>
                        <button
                            className="jump-to-link"
                            onClick={(): void => {
                                history.push(Routes.admin.createReport);
                            }}
                        >
                            Create Report
                        </button>
                        <span className="divider">|</span>
                        <button
                            className="jump-to-link"
                            onClick={(): void => {
                                history.push(Routes.admin.editSchool);
                            }}
                        >
                            Edit School
                        </button>
                    </div>
                    <div className="page-section admin__body">
                        <Body style={{ fontWeight: "bold" }}>
                            ACSI admins should follow the above actions in the order they are listed:
                        </Body>
                        <br />
                        <br />
                        <ol>
                            <li>Create School</li>
                            <li>Create User (a user cannot exist without a school)</li>
                            <ul>
                                <li>
                                    Password Requirements: minimum 8 characters with at least 1 lower case character, 1
                                    upper case character, and 1 numeric digit
                                </li>
                            </ul>
                            <li>
                                Create Report (which will then allow that school to generate a report when they are
                                ready / their surveys are complete)
                            </li>
                            <ul>
                                <li>Any given school can have only 1 Report per school year (or per payment).</li>
                                <li>
                                    If you are unsure if a report already exists for a particular school, try creating
                                    one. If one does exist already, you will see a red "error" notification. If a report
                                    has not been created yet, you will see a green "success" notification. Simple as
                                    that!
                                </li>
                            </ul>
                        </ol>
                        <br />
                        <Body>
                            Use Edit School at any time to correct a school's name or address, or to record its ACSI
                            account number. The account number appears only in these admin dropdowns, never on a report.
                        </Body>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
};
